export class SaleOfferDepartureReason {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new SaleOfferDepartureReason(
      this.hash,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-departure-reason.ts